<template>
  <div>
    <Toast style="" />
    <div class="action">
      <div class="profile" @click="menuToggle">
        <i class="pi pi-user"><span class="main-username">{{user.username}}</span></i>
      </div>
      <div class="menu">
        <h3>{{user.username.toUpperCase()}}<br><span></span></h3>
        <ul>
          <li><i class="pi pi-refresh"></i><a @click.prevent="openOrganisationUpdate">Update Organisation</a></li>
          <li><i class="pi pi-user-edit"></i><a @click.prevent="openDialog">Change Password</a></li>
          <li><i class="pi pi-sign-out"></i><a @click.prevent="logout">Logout</a></li>
        </ul>
      </div>
    </div>
    <form>
      <Dialog header="Change Password" :visible.sync="changePassword" 
      :style="{ width: '700px !important' }" :modal="true" :closable="false">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-12">
            <label for="oldPassword">Old Password<span style="color:red">*</span></label>
            <Password id="oldPassword" v-model="oldPassword" toggleMask :feedback="false" />
          </div>

          <div class="p-field p-col-12 p-md-12">
            <label for="newPass">New Password<span style="color:red">*</span></label>
            <Password id="newPass" v-model="newPassword" toggleMask :feedback="false" />
          </div>

          <div class="p-field p-col-12 p-md-12">
            <label for="confirmPass">Confirm Password<span style="color:red">*</span></label>
            <Password id="confirmPass" v-model="confirmPassword" toggleMask :feedback="false" />
          </div>

          <div v-if="errorMessage" class="p-col-12 p-md-12 error-message">
            {{ errorMessage }}
          </div>
        </div>
        <template #footer>
          <div class="dialog-footer">
            <Button label="Send Code" @click="updatePassword" :loading="loading" class="p-button-primary" />
            <Button label="Cancel" @click="cancel" class="p-button-danger" />
          </div>
        </template>
      </Dialog>
      <Dialog header="Verify Code" :visible.sync="showCodeDialog" 
      :style="{ width: '700px !important' }" :modal="true" :closable="false">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-12">
            <label for="verificationCode">Verification Code<span style="color:red">*</span></label>
            <InputText id="verificationCode" v-model="verificationCode" 
                      placeholder="Enter 6-digit code" maxlength="6" />
          </div>

          <div v-if="errorMessage" class="p-col-12 p-md-12 error-message">
            {{ errorMessage }}
          </div>
        </div>
        <template #footer>
          <div class="dialog-footer">
            <Button label="Verify & Reset" @click="verifyCodeAndReset" :loading="loading" class="p-button-primary" />
            <Button label="Cancel" @click="cancel" class="p-button-danger" />
          </div>
        </template>
      </Dialog>
      <UpdateOrganisation v-model="updateOrganisation" @cancel="cancelUpdateOrg"/>
   </form>
 </div>
</template>

<script>
import Dialog from 'primevue/dialog'
import Toast from 'primevue/toast'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Password from 'primevue/password'
import UpdateOrganisation from './UpdateOrganisation.vue'
import axios from 'axios'
import globalKey from '@/store/globalKey'
export default {
  name: 'UserMenu',
  data() {
    return {
      changePassword: false,
      showCodeDialog: false,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      verificationCode: '',
      updateOrganisation: false,
      loading: false,
      errorMessage: ''
    }
  },
  props: ['user'],
  computed: {
    organisationID() {
      return this.$store.state.organisationid
    },
    userID() {
      return this.$store.state.user.id
    }
  },
  methods: {
    logout() {
      localStorage.clear()
      // window.location.reload()
      this.$router.go('/login')
    },
    async updatePassword() {
      if (this.oldPassword === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Old password is required!', life: 10000})
        return
      }
      if (this.newPassword === '' || this.confirmPassword === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'All fields are required!', life: 10000})
        return
      }
      if (this.newPassword !== this.confirmPassword) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Passwords do not match!', life: 10000})
        return
      }
      this.loading = true
      try {
        const verifyResponse = await axios.post(
          `${globalKey}/passwordReset/verify-old-password/${this.userID}/${this.organisationID}`,
          { oldPassword: this.oldPassword }
        )
        if (verifyResponse.data.status === 'ERROR') {
          this.$toast.add({severity: 'error', summary: 'Error', detail: verifyResponse.data.message, life: 10000})
          return
        }
        const response = await axios.post(
          `${globalKey}/passwordReset/initiate/${this.userID}/${this.organisationID}`
        )
        if (response.data.status === 'ERROR') {
          this.$toast.add({severity: 'error', summary: 'Error', detail: response.data.message, life: 10000})
          return
        }
        if (response.data.status === 'SUCCESS') {
          this.changePassword = false
          this.showCodeDialog = true
          this.$toast.add({severity: 'success', summary: '', detail: 'Verification code sent to your email', life: 10000})
        }
      } catch (error) {
        this.errorMessage = error.response.data.message || 'Failed to send verification code'
        this.$toast.add({severity: 'error', summary: '', detail: this.errorMessage, life: 10000})
      } finally {
        this.loading = false
      }
    },

    async verifyCodeAndReset() {
      if (!this.verificationCode) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter verification code', life: 10000})
        return
      }

      this.loading = true
      try {
        const response = await axios.post(
          `${globalKey}/passwordReset/verify-code/${this.userID}/${this.organisationID}`, {
            token: this.verificationCode,
            oldPassword: this.oldPassword,
            newPassword: this.newPassword
          }
        )
        if (response.data.status === 'ERROR') {
          this.$toast.add({severity: 'error', summary: 'Error', detail: response.data.message, life: 10000})
          return
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: 'Password reset successfully!', life: 10000})
          this.cancel()
        }
      } catch (error) {
        this.errorMessage = error.response.data.message || 'Password reset failed'
        this.$toast.add({severity: 'error', summary: '', detail: this.errorMessage, life: 10000})
      } finally {
        this.loading = false
      }
    },
    async openOrganisationUpdate() {
      this.updateOrganisation = true
    },
    cancelUpdateOrg() {
      this.updateOrganisation = false
    },
    menuToggle() {
      const toggleMenu = document.querySelector('.menu')
      toggleMenu.classList.toggle('active')
    },
    openDialog() {
      this.changePassword = true
    },
    cancel() {
      this.changePassword = false
      this.showCodeDialog = false
      this.reset()
    },
    reset() {
      this.oldPassword = ''
      this.newPassword = ''
      this.confirmPassword = ''
      this.verificationCode = ''
      this.errorMessage = ''
    }
  },
  components: {
    Dialog,
    Button,
    Toast,
    Password,
    InputText,
    UpdateOrganisation
  }
}
</script>
<style scoped>
.action {
  width: 200px;
  position: relative;
}
.action .profile{
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: visible;
  cursor: pointer;
  background: rgba(220, 230, 237, 0.1);
  border: 2px solid #829AB1;
  padding: 1rem;
  text-align: center;
}

.action .menu {
  position: absolute;
  top: 100%;
  right: 0;
  padding: 10px 0px;
  border-radius: 15px;
  background: #F5F7FA;
  box-shadow: 0 2px 8px 0 rgb(25 26 28 / 12%);
  width:200px;
  transition: 0.5s;
  visibility: hidden;
  opacity:0;
  cursor: pointer;
  z-index: 1000;
}
.action .menu.active {
  visibility: visible;
  opacity:1;
}
.action .menu::before{
  content: '';
  position: absolute;
  top:-5px;
  right: 28px;
  width:20px;
  height: 20px;
  background: #F5F7FA;
  transform: rotate(45deg);
}
.action .menu h3{
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color:#555;
  line-height: 1.2em;
}
.action .menu h3 span {
  font-size: 14px;
  color: #cecece;
  font-weight: 400;
}
.action .menu ul li {
  list-style: none;
  padding: 10px;
  border-top: 1px solid rgba(0,0,0,0.05);
  display: flex;
  align-items: center;
}
.action .menu ul li i{
  max-width: 20px;
  margin-right: 10px;
  opacity: 0.5;
  transition: 0.5s;
}
.action .menu ul li:hover i{
  opacity: 1;
}
.action .menu ul li a{
  display: inline-block;
  text-decoration: none;
  color: #555;
  font-weight: 500;
  transition: 0.5s;
}
.action .menu ul li:hover a {
  color: #ff5d94;
}

.pi-user {
  font-size: 2.2rem;
  color : #3e4c59;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  width: 100%;
}

.dialog-footer .p-button {
  min-width: 120px;
}

@media only screen and (min-width: 768px) {
  .pi-user {
    font-size: 1.4rem;
  }
  .action .profile{
    border: 1px solid #829AB1;
    border-radius: 5px;
    padding: 0.5rem 1rem;
    width: auto;
    height: auto;
  }
}
@media only screen and (min-width: 992px) {
  .pi-user {
    font-size: 2.2rem;
  }

  .action .profile{
    border: 2px solid #829AB1;
    border-radius: 10px;
  }
}

.main-username {
  font-family: 'Lato', sans-serif;
  margin-left: 10px;
  font-size: 1.6rem;
  font-weight: 700;
}
.error-message {
  color: #ff0000;
  margin-top: 1rem;
  padding: 0.5rem;
  background-color: #ffe6e6;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// UserMenu.vue?34408e24